export const LEFT = 'LEFT';
export const RIGHT = 'RIGHT';


// WEBPACK FOOTER //
// ./src/app/constants/Commands.js